import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserAffiliateInfoModalComponent } from '../user-affiliate-info-modal/user-affiliate-info-modal.component';

@Component({
  selector: 'app-user-affiliate-info-panel',
  templateUrl: './user-affiliate-info-panel.component.html',
  styleUrls: ['./user-affiliate-info-panel.component.scss'],
})
export class UserAffiliateInfoPanelComponent {
  constructor(private dialog: MatDialog) {}

  openModal() {
    this.dialog.open(UserAffiliateInfoModalComponent);
  }
}
